module.exports = __webpack_public_path__ + "static/vault-web4-2035a58d60d71ac7c2c740b01db58c20.png";